import axios from "axios";

const putPatientForgotPasswordUpdate = async (baseUrl, token, userToken, newPassword) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + `/patient/password/update?token=` + userToken + "&newpassword=" + newPassword, {}, config)
        .then((res) => {
            putResponse = {
                status: res.data.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return putResponse
}

export default putPatientForgotPasswordUpdate;